export class Url {
    public static set(url: string) {
        history.pushState({}, "", url);
    }
}